import React from 'react';

export default function TableIcon({ width, height, style, className }) {
  const _width = width ?? 17;
  const _height = height ?? _width;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      height={_height}
      viewBox="0 -960 960 960"
      width={_width}
      className={className}
    >
      <path d="m240-160 60-150q9-23 29-36.5t45-13.5h66v-161q-153-5-256.5-45T80-660q0-58 117-99t283-41q167 0 283.5 41T880-660q0 54-103.5 94T520-521v161h66q24 0 44.5 13.5T660-310l60 150h-80l-48-120H368l-48 120h-80Zm240-440q97 0 183-17t126-43q-40-26-126-43t-183-17q-97 0-183 17t-126 43q40 26 126 43t183 17Zm0-60Z" />
    </svg>
  );
}
